import React from "react";
import { useLanguage } from "../context/LanguageContext";

const DifferenceSection = () => {
  const { language } = useLanguage();
  
  const content = {
    sl: {
      label: "V ČEM SMO DRUGAČNI",
      title: "Večina računovodij beleži vašo preteklost.",
      titleHighlight: "Mi vam pomagamo pisati prihodnost.",
      description: "Dobite nekoga, ki vam pove,",
      descriptionBold: "koliko vas bo odločitev stala, še preden jo sprejmete",
      descriptionEnd: " — in osebnega skrbnika, ki vaše podjetje pozna po imenu, ne po številki mape.",
      pillars: [
        {
          num: "I.",
          title: "Proaktivno, ne za nazaj",
          text: "Davčna optimizacija in načrtovanje denarnega toka pred zaključkom leta — ne po njem."
        },
        {
          num: "II.",
          title: "Vse na enem mestu",
          text: "Ustanovitev, knjigovodstvo, DDV, plače, dovoljenja in celo pisarna — ena ekipa."
        },
        {
          num: "III.",
          title: "Na daljavo, v vašem jeziku",
          text: "Slovensko, angleško, srbohrvaško ali špansko — prilagodimo se vam. Brez papirja in večinoma na daljavo."
        }
      ]
    },
    en: {
      label: "THE GENERAL LEDGER DIFFERENCE",
      title: "Most accountants record your history.",
      titleHighlight: "We help you write it.",
      description: "You get someone who tells you",
      descriptionBold: "what a decision will cost before you make it",
      descriptionEnd: " — and a dedicated account manager who knows your company by name, not by file number.",
      pillars: [
        {
          num: "I.",
          title: "Proactive, not reactive",
          text: "Tax optimisation and cash-flow planning before the year closes — not after."
        },
        {
          num: "II.",
          title: "One door for everything",
          text: "Formation, bookkeeping, VAT, payroll, permits and even your office — one team."
        },
        {
          num: "III.",
          title: "Remote, in your language",
          text: "Slovenian, English, Serbo-Croatian or Spanish — we adapt to you. Paperless and mostly remote."
        }
      ]
    }
  };
  
  const t = content[language] || content.sl;
  
  return (
    <section className="px-6 lg:px-[120px] pt-24 lg:pt-32 bg-[#F6F2EA]" data-testid="difference-section">
      <div className="max-w-[1440px] mx-auto">
        <div className="bg-[#0E1114] text-[#F4EFE6] flex flex-col lg:flex-row animate-on-scroll">
          {/* Image */}
          <div className="w-full lg:w-[480px] h-[300px] lg:h-auto flex-shrink-0 animate-on-scroll from-left">
            <picture>
              <source srcSet="/images/team-office.webp" type="image/webp" />
              <img 
                src="/images/team-office.jpg" 
                alt={language === 'en' ? "The General Ledger accounting team's office" : "Pisarna računovodske ekipe General Ledger"}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </picture>
          </div>
          
          {/* Content */}
          <div className="flex-grow p-8 lg:p-16 xl:p-20 flex flex-col gap-7">
            <span className="text-[13px] font-bold tracking-[2.5px] text-[#C9A462]">{t.label}</span>
            <h2 className="font-serif text-3xl lg:text-[56px] leading-[1.02] tracking-[-1px]">
              {t.title} <span className="italic text-[#C9A462]">{t.titleHighlight}</span>
            </h2>
            <p className="text-lg leading-[1.65] text-[#C9C3B7]">
              {t.description} <strong className="text-[#F4EFE6]">{t.descriptionBold}</strong>{t.descriptionEnd}
            </p>
            
            {/* Three Pillars */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-7 border-t border-[#2A3036] pt-7 mt-2">
              {t.pillars.map((pillar) => (
                <div key={pillar.num} className="flex flex-col gap-2">
                  <span className="font-serif text-[30px] text-[#C9A462]">{pillar.num}</span>
                  <span className="text-[17px] font-bold">{pillar.title}</span>
                  <span className="text-sm leading-[1.55] text-[#B9B3A7]">{pillar.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DifferenceSection;
